import { Button } from '@/components/ui/button'
import { Trash2 , LogOut} from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'
import { staffLogOutApi } from '@/api/staff'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import useAuth from '@/hooks/useAuth'
export function LogOutDialog ({
  isOpen,
  onClose,
  onConfirm
}) {
  const navigate = useNavigate();
  const restaurant_system_id = useAuth()?.user?.restaurant_system_id;
    function logOut(){
        const activeRestaurantId = localStorage.getItem("restaurant_system_id") || restaurant_system_id;

        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("tags")
        // Keep restaurant_system_id so the POS terminal stays attached to this restaurant
        if (activeRestaurantId) {
          navigate(`/${activeRestaurantId}`)
        } else {
          navigate("/")
        }

        staffLogOutApi({ restaurant_system_id }).then((data)=>{   staffLogOutApi
           if(data?.status == "success"){
            toast.success("Logout Successfully.")
           }else{
            toast.error(data?.message)
            console.log(data)
           }
        })
    }




  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='sm:max-w-[425px]'>
        <DialogHeader className={`flex justify-center items-center gap-2`}>
          <Button className='bg-cblack7' size='icon' variant=''>
            <LogOut className='text-cyellow' />
          </Button>
          <DialogTitle>Are you sure delete?</DialogTitle>
          <DialogDescription>
            You want to log out form this module.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className={`flex w-full justify-center gap-5 items-center`}>
            <Button className='bg-cblack7 text-cwhite2' onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant='destructive'
              className='bg-cred'
              onClick={logOut}
            >
              Yes, Log Out
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}